import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://ulvxgxlokcslxznjthzo.supabase.co';
const SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVsdnhneGxva2NzbHh6bmp0aHpvIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTkzNTYwNzAsImV4cCI6MjAxNDkzMjA3MH0.bbImrTyWqdJHePVS_PO5Own_720qW2waptwNGqatQ20';
 
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON); 